import { PlatformData } from '../ModuleConfig';

export interface ReactModuleConfigData extends PlatformData {
  '@type': 'type.googleapis.com/terra.v1.ReactModuleConfigData';
  componentName: string;
  enableDeveloperSupport: string;
  linkProcessorClass: string;
}

export const ReactNativeModuleConfigDataFields: (keyof ReactModuleConfigData)[] = [
  'componentName',
  'enableDeveloperSupport',
  'linkProcessorClass',
];
